import { useContext } from 'react';
import { ProjectContext } from '../contexts';

const useProject = () => {
  const project = useContext(ProjectContext);
  if (project === null) throw new Error('Invalid project context.');
  return project;
};

export { useProject };
